import { createContext, useContext } from 'react'

// Shared data hooks consume JWT through this context so auth source can vary by runtime.
export const JwtTokenContext = createContext<string | null>(null)

// Backward-compatible hook used across shared queries.
export const useJwtToken = () => useContext(JwtTokenContext)
